import React from "react";
import './SideBar.css'
import $ from 'jquery';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFilePen, faRightFromBracket, faGauge, faThList } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from "react-router-dom";
import { UserOutlined } from '@ant-design/icons';

$(function () {
    $('.box-menu .wrapper').on('click', function () {
        $('.box-menu').toggleClass('full-menu');
        $('.hamburger').toggleClass('active');
    });
    $('a').on('click', function () {
        $(this).siblings('a').removeClass('active');
        $(this).addClass('active');
    });
});

function SideBar({ UserInfo, ActivePage, setActivePage }) {
    let src = "https://gologinapi.nipponpaint.co.in//images/EmployeePhoto/" + UserInfo[0]?.photo;
    const Images = src.replace(/,function \(\) \{ \[native code\] \}$/, '').trim();
    const Navigate = useNavigate()

    const Logout = () => {
        Navigate("/")
        sessionStorage.clear()
        window.location.reload(false);
    }

    const OnPageSelect = (Pages) => {
        setActivePage(Pages)
        Navigate('/' + Pages)
    }

    return (
        <>
            <div className="SideBarMainClass">
                <div className="avatar">
                    {UserInfo[0]?.photo !== "" ?
                        <UserOutlined className="thumb" width="60" height="60" />
                        :
                        <UserOutlined style={{ fontSize: '20px', color: 'white' }} />
                    }
                    <div className="name">{UserInfo[0]?.employeeName}</div>
                    <div className="name EmpNo_Divition">{UserInfo[0]?.employeeId}</div>
                    <div className="name EmpNo_Divition">{UserInfo[0]?.divisionName}</div>
                </div>
                <nav className="primary">
                    <a className={ActivePage === "Dashboard" ? "SideBarMainClass-item active" : "SideBarMainClass-item"} onClick={() => OnPageSelect("")}>
                        <FontAwesomeIcon icon={faGauge} />
                        <span className="desc" >Dashboard</span>
                    </a>
                    < a className={ActivePage === "FormPage" ? "SideBarMainClass-item active" : "SideBarMainClass-item"} onClick={() => OnPageSelect("BasicPermit")}>
                        <FontAwesomeIcon icon={faFilePen} />
                        <span className="desc" >Request View</span>
                    </a>
                    {UserInfo[0]?.isApprover === true && <a className={ActivePage === "ViewApprovalPage" ? "SideBarMainClass-item active" : "SideBarMainClass-item"} onClick={() => OnPageSelect("ViewApprovalPage")}>
                        <FontAwesomeIcon icon={faEye} />
                        <span className="desc">Approval List</span>
                    </a>
                    }
                    {UserInfo[0]?.isExtensionApprover === true && <a className={ActivePage === "ExtensionApprovalPage" ? "SideBarMainClass-item active" : "SideBarMainClass-item"} onClick={() => OnPageSelect("ExtensionApprovalPage")}>
                        <FontAwesomeIcon icon={faThList} />
                        <span className="desc">Extension List</span>
                    </a>
                    }
                    <a className="SideBarMainClass-item" onClick={() => Logout()}>
                        <FontAwesomeIcon icon={faRightFromBracket} />
                        <span className="desc">Logout</span>
                    </a>
                </nav>
            </div >
        </>
    )
}
export default SideBar;